// userSlice.ts
import { createSlice, createAsyncThunk, SerializedError } from '@reduxjs/toolkit';
import axios from 'axios';
import { decryptData } from '../../helpers/functions/functions';

// Async thunk to fetch user by slug
export const fetchUserBySlug = createAsyncThunk(
  'user/fetchBySlug',
  async (slug: string) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/card/${slug}`);
    const decrypted = decryptData(response.data.enc);
    return decrypted;
  }
);

// Define the shape of user state
interface UserState {
  data: any | null;
  loading: boolean;
  error: SerializedError | null;
}

const initialState: UserState = {
  data: null,
  loading: false,
  error: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserBySlug.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchUserBySlug.rejected, (state, action) => {
        state.error = action.error;
        state.loading = false;
      });
  }
});

export default userSlice.reducer;
